import React from "react";

const GrassurnLogo = ({ size = "medium", isDark = false, className = "" }) => {
  // Optimized logo sizes following industry standards and responsive design
  const sizeConfig = {
    small:  { width: "140", height: "105" },
    medium: { width: "180", height: "135" },
    large:  { width: "220", height: "165" },
    xlarge: { width: "260", height: "195" },
    header: { width: "196", height: "41"  },
    footer: { width: "300", height: "65"  },
    nav:    { width: "230", height: "48"  },
  };

  const { width, height } = sizeConfig[size] || sizeConfig.medium;

  // Choose logo based on background
  const logoSrc = isDark ? "/grassurn-logo-dark.png" : "/grassurn-logo.png";

  return (
    <div className={`inline-flex items-center ${className}`}>
      <img
        src={logoSrc}
        alt="Grassurn Tech - AI & Innovation Studio"
        width={width}
        height={height}
        className="flex-shrink-0 object-contain"
        style={{ 
          maxWidth: width + 'px', 
          maxHeight: height + 'px',
          width: 'auto',
          height: 'auto'
        }}
      />
    </div>
  );
};

export default GrassurnLogo;